export const initialState = {
    IsCreate: false,
    IsRead: false,
    IsUpdate: false,
    IsDelete: false
};